export * from './VerifyPhoneIcon';
